export default __webpack_public_path__ + "static/media/ReactJS.116e502c.svg";